import { Project as ProjectBreadcrumb } from '../../../breadcrumbs/models/Project';
import { GQLIdEncoder, ModelType } from '../../../common/utils/GQLIdEncoder';
import { Project } from '../models/Project';

export class ProjectBreadcrumbMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapToBreadcrumb(project: Project): ProjectBreadcrumb {
    return new ProjectBreadcrumb(this.gqlIdEncoder.encode(ModelType.Project, project.getId()), project.getId(), project.getName());
  }
}
